var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"virus-modal"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_c('img',{staticClass:"img-virus",attrs:{"src":require("../assets/img/virus-2.png"),"alt":""}}),_c('img',{staticClass:"img-forward",attrs:{"src":require("../../assets/img/arrow.png"),"alt":""},on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }